export const CATEGORY_FOOTER_CITIES = [
	{ name: 'Atlanta', slug: 'atlanta-ga', stateCode: 'GA' },
	{ name: 'Austin', slug: 'austin-tx', stateCode: 'TX' },
	{ name: 'Baltimore', slug: 'baltimore-md', stateCode: 'MD' },
	{ name: 'Boston', slug: 'boston-ma', stateCode: 'MA' },
	{ name: 'Buffalo', slug: 'buffalo-ny', stateCode: 'NY' },
	{ name: 'Cape Cod', slug: 'cape-cod-ma', stateCode: 'MA' },
	{ name: 'Charleston', slug: 'charleston-sc', stateCode: 'SC' },
	{ name: 'Charlotte', slug: 'charlotte-nc', stateCode: 'NC' },
	{ name: 'Chicago', slug: 'chicago-il', stateCode: 'IL' },
	{ name: 'Cincinnati', slug: 'cincinnati-oh', stateCode: 'OH' },
	{ name: 'Cleveland', slug: 'cleveland-oh', stateCode: 'OH' },
	{ name: 'Columbus', slug: 'columbus-oh', stateCode: 'OH' },
	{ name: 'Dallas', slug: 'dallas-tx', stateCode: 'TX' },
	{ name: 'Denver', slug: 'denver-co', stateCode: 'CO' },
	{ name: 'Detroit', slug: 'detroit-mi', stateCode: 'MI' },
	{ name: 'Grand Rapids', slug: 'grand-rapids-mi', stateCode: 'MI' },
	{ name: 'Honolulu', slug: 'honolulu-hi', stateCode: 'HI' },
	{ name: 'Houston', slug: 'houston-tx', stateCode: 'TX' },
	{ name: 'Indianapolis', slug: 'indianapolis-in', stateCode: 'IN' },
	{ name: 'Irvine', slug: 'irvine-ca', stateCode: 'CA' },
	{ name: 'Jacksonville', slug: 'jacksonville-fl', stateCode: 'FL' },
	{ name: 'Jersey City', slug: 'jersey-city-nj', stateCode: 'NJ' },
	{ name: 'Kansas City', slug: 'kansas-city-mo', stateCode: 'MO' },
	{ name: 'Las Vegas', slug: 'las-vegas-nv', stateCode: 'NV' },
	{ name: 'Long Island', slug: 'long-island-ny', stateCode: 'NY' },
	{ name: 'Los Angeles', slug: 'los-angeles-ca', stateCode: 'CA' },
	{ name: 'Memphis', slug: 'memphis-tn', stateCode: 'TN' },
	{ name: 'Miami', slug: 'miami-fl', stateCode: 'FL' },
	{ name: 'Milwaukee', slug: 'milwaukee-wi', stateCode: 'WI' },
	{ name: 'Minneapolis', slug: 'minneapolis-mn', stateCode: 'MN' },
	{ name: 'New Haven', slug: 'new-haven-ct', stateCode: 'CT' },
	{ name: 'New Orleans', slug: 'new-orleans-la', stateCode: 'LA' },
	{ name: 'New York', slug: 'new-york-ny', stateCode: 'NY' },
	{ name: 'Orlando', slug: 'orlando-fl', stateCode: 'FL' },
	{ name: 'Philadelphia', slug: 'philadelphia-pa', stateCode: 'PA' },
	{ name: 'Phoenix', slug: 'phoenix-az', stateCode: 'AZ' },
	{ name: 'Pittsburgh', slug: 'pittsburgh-pa', stateCode: 'PA' },
	{ name: 'Portland', slug: 'portland-or', stateCode: 'OR' },
	{ name: 'Providence', slug: 'providence-ri', stateCode: 'RI' },
	{ name: 'Richmond', slug: 'richmond-va', stateCode: 'VA' },
	{ name: 'Sacramento', slug: 'sacramento-ca', stateCode: 'CA' },
	{ name: 'San Antonio', slug: 'san-antonio-tx', stateCode: 'TX' },
	{ name: 'San Diego', slug: 'san-diego-ca', stateCode: 'CA' },
	{ name: 'San Francisco', slug: 'san-francisco-ca', stateCode: 'CA' },
	{ name: 'Santa Barbara', slug: 'santa-barbara-ca', stateCode: 'CA' },
	{ name: 'Seattle', slug: 'seattle-wa', stateCode: 'WA' },
	{ name: 'St. Louis', slug: 'st-louis-mo', stateCode: 'MO' },
	{ name: 'Tampa', slug: 'tampa-fl', stateCode: 'FL' },
];
